var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"themeSels",staticClass:"theme-color-content clearfix"},_vm._l((_vm.colors),function(item,index){return _c('div',{key:index,ref:item.id,refInFor:true,staticClass:"theme-color-block",style:(_vm.itemStyle(item)),attrs:{"title":item.text},on:{"click":function($event){return _vm.itemClick(item,$event)}}})}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/go-color-theme-sel.vue